import { MESSAGE_TYPE } from "@/domains/messages/models/constants";
import type { MessageDataModel } from "@/domains/messages/models/types";

export const createMessagesDataModel = (messages: MessageDataModel[]) => {
  return {
    hasMessages: messages.length > 0,
    threadId: messages[0]?.threadId,
    messagesByDay: getMessagesByDay(messages),
    latestSystemMessage: messages
      .filter((message) => {
        return message.type === MESSAGE_TYPE.SYSTEM || message.type === MESSAGE_TYPE.CLINICIAN;
      })
      .at(-1),
  };
};

const getMessagesByDay = (messages: MessageDataModel[]) => {
  const result: Record<string, typeof messages> = {};

  messages.forEach((message) => {
    const day = message.createdAt.split("T")[0];
    if (!result[day]) {
      result[day] = [];
    }
    result[day].push(message);
  });

  Object.keys(result).forEach((day) => {
    result[day].sort((a, b) => {
      return a.createdAt.localeCompare(b.createdAt);
    });
  });

  return Object.fromEntries(
    Object.entries(result).sort(([a], [b]) => {
      return a.localeCompare(b);
    }),
  );
};
